module.exports = __webpack_public_path__ + "static/media/trust-wallet.12d5f742.png";